module.exports = __webpack_public_path__ + "static/media/Madfit-7.25d32e1b.jpg";